import Button from './_button.js'
import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import Text from './_text.js'

export default {
  name: 'ImageButton',
  values: {
    button: {
      configSet: Button,
      configValues: {},
    },
    innerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          alignItems: 'center',
        },
      },
    },
    buttonIcon: {
      configSet: Image,
      configValues: {},
    },
    buttonLabel: {
      configSet: Text,
      configValues: {},
    },
    buttonIconActive: {
      configSet: Image,
      configValues: {},
    },
    buttonLabelActive: {
      configSet: Text,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
